<template>
  <div>
    <div class="ma-4 px-4">
      <v-sheet outlined>
        <v-data-table
          :headers="settlementHeaders"
          :items="settlements"
          fixed-header
          :items-per-page="5"
          hide-default-footer
          class="secondary row-height-50"
        >
          <template #[`item.date`]="{ value }">
            {{ formatDate(value, false) }}
          </template>
        </v-data-table>
      </v-sheet>
      <div class="pt-4">
        <span class="text-5xl font-weight-bold accent--text">
          Settled Transactions
        </span>
      </div>
      <v-row class="mt-2">
        <v-col cols="12">
          <v-sheet outlined>
            <v-data-table
              :headers="settlementTransactionHeaders"
              :items="settlementTransactions"
              fixed-header
              class="secondary row-height-40"
            >
              <template #[`item.tx_date`]="{ value }">
                {{ formatDates(value, true) }}
              </template>
              <template #[`item.batch`]="{ item }">
                {{item.year}}-{{ item.batch }}
              </template>
              <template #[`item.settlement_date`]="{ value }">
                {{ formatDates(value, true) }}
              </template>
              <template #[`item.application_id`]="{ value }">
                {{ value ? value : "-" }}
              </template>
              <template #[`item.usn_id`]="{ value }">
                {{ value ? value : "-" }}
              </template>
              <template #[`item.is_excess`]="{ value }">
                {{ value ? "Yes" : "No" }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  settlementHeaders,
  settlementTransactionHeaders,
} from "@/constants/headers";
export default {
  data() {
    return {
      settlementHeaders: settlementHeaders,
      settlementTransactionHeaders: settlementTransactionHeaders,
      settlements: [],
      settlementTransactions: [],
      currentSettlementPV: null,
    };
  },
  watch: {},
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
  async created() {
    this.currentSettlementPV = this.$route.params.id;
    this.$store.commit("setBreadcrumbs", [
      { text: "Settlements", to: { name: "Settlements" } },
      { text: "Transactions" },
    ]);

    this.initialise();
    if (this.settlementHeaders)
      this.settlementHeaders = this.settlementHeaders.slice(0, -1);
  },
  methods: {
    async initialise() {
      await this.getSettlements();
    },
    async getSettlements() {
      await this.$axios
        .get("/get_settlement_by_pv_number/" + this.currentSettlementPV)
        .then((res) => {
          this.settlements = [res.data.data];
          this.settlementTransactions =
            this.settlements[0].settled_transactions;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message || "No Data Found",
            color: "error",
          });
        });
    },
    formatDate(dateString, needHour) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hour = date.getHours().toString().padStart(2, "0");
      const minute = date.getMinutes().toString().padStart(2, "0");
      return needHour
        ? `${month}-${day}-${year} ${hour}:${minute}`
        : `${day}-${month}-${year}`;
    },
    formatDates(dateString, needHour) {
      if (!dateString) return "-";

      // Split date and time parts
      const [datePart, timePart] = dateString.split(" ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hour = 0, minute = 0, second = 0] = (timePart || "00:00:00")
        .split(":")
        .map(Number);

      // Build a valid JS Date
      const date = new Date(year, month - 1, day, hour, minute, second);

      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      const hh = String(date.getHours()).padStart(2, "0");
      const min = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");

      return needHour
        ? `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`
        : `${dd}-${mm}-${yyyy}`;
    },
  },
};
</script>

<style scoped>
.v-data-table::v-deep th {
  padding-right: 0px !important;
  font-size: 11px !important;
}
.v-data-table::v-deep td {
  font-size: 11px !important;
  padding-right: 0px !important;
}
</style>